var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRBill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 28 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "search"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "file"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "file-earmark"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "file1",
    serifid: "file"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass1",
    serifid: "magnifying-glass"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-bill",
    x: 0,
    y: 0,
    width: 28,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.314,18.986c-0.064,-0.005 -3.391,-0.237 -5.851,-0.197c-4.263,0.068 -8.828,0.608 -11.234,0.608c-1.965,0 -5.455,-0.227 -5.54,-0.233c-0.001,0 -0.003,0 -0.004,0c-0.889,-0.002 -1.609,-0.722 -1.61,-1.611c0,-0 0,-10.958 0,-10.958c0.001,-0.89 0.722,-1.611 1.611,-1.612c0.062,0.004 3.571,0.233 5.543,0.233c2.407,0 6.972,-0.54 11.235,-0.608c2.45,-0.04 5.76,0.19 5.847,0.196c0.001,0 0.003,0 0.004,0c0.889,0.002 1.609,0.723 1.61,1.612c-0,-0 -0,10.958 -0,10.958c-0.001,0.889 -0.722,1.61 -1.611,1.612Zm-22.624,-12.645l-0.007,-0c-0.138,0.002 -0.25,0.115 -0.25,0.254l-0,10.958c-0,0.14 0.113,0.253 0.253,0.253c0.051,0.004 3.568,0.234 5.543,0.234c2.407,-0 6.972,-0.54 11.235,-0.609c2.446,-0.039 5.747,0.19 5.846,0.197l0.009,-0c0.137,-0.003 0.248,-0.116 0.248,-0.254l0,-10.958c0,-0.14 -0.113,-0.253 -0.253,-0.254c-0.193,-0.001 -3.388,-0.236 -5.851,-0.197c-4.263,0.069 -8.828,0.609 -11.234,0.609c-1.961,-0 -5.441,-0.227 -5.539,-0.233Zm6.149,9.47c0,-0.392 -0.324,-0.731 -0.723,-0.731c0,-0 -3.41,-0 -3.41,-0c-0.399,-0 -0.724,0.319 -0.724,0.712c0,0.392 0.325,0.712 0.724,0.712c0,-0 3.41,-0 3.41,-0c0.4,-0 0.723,-0.3 0.723,-0.693Zm4.587,-6.78l-0,-0.1c-0,-0.344 0.279,-0.623 0.624,-0.623c0.344,-0 0.623,0.279 0.623,0.623l0,0.105c0.945,0.067 1.693,0.673 1.694,1.637l-0,-0c-0,0.344 -0.279,0.624 -0.624,0.624c-0.344,-0 -0.623,-0.28 -0.623,-0.624c-0,-0.12 -0.022,-0.205 -0.063,-0.264c-0.046,-0.065 -0.116,-0.096 -0.199,-0.113c-0.096,-0.018 -0.208,-0.018 -0.327,-0.018c0,-0 -1.084,-0 -1.084,-0c-0.321,-0 -0.581,0.26 -0.581,0.581c-0,0.321 0.26,0.581 0.581,0.581l1.326,0c1.009,0.002 1.827,0.82 1.828,1.829l0,0c-0.001,1.01 -0.819,1.827 -1.828,1.829l-0.1,-0l0,0.099c0,0.344 -0.279,0.624 -0.623,0.624c-0.345,-0 -0.624,-0.28 -0.624,-0.624l-0,-0.099l-0.1,-0c-0.816,-0.001 -1.82,-0.225 -1.822,-1.636c-0,0.002 -0,-0 -0,-0c-0,-0.345 0.279,-0.624 0.624,-0.624c0.344,0 0.623,0.28 0.623,0.624c0.001,0.316 0.259,0.388 0.576,0.388c-0,0 1.446,0 1.446,0c0.321,0 0.581,-0.26 0.581,-0.581c-0,-0.321 -0.26,-0.581 -0.581,-0.581c-0,-0 -1.326,-0 -1.326,-0c-1.01,-0 -1.829,-0.819 -1.829,-1.829c0,-1.003 0.808,-1.817 1.808,-1.828Zm5.726,-0.943c0,0.393 0.312,0.74 0.695,0.74c0,-0 3.466,-0 3.466,-0c0.384,-0 0.696,-0.319 0.696,-0.712c-0,-0.394 -0.312,-0.712 -0.696,-0.712c0,-0 -3.466,-0 -3.466,-0c-0.384,-0 -0.695,0.29 -0.695,0.684Z",
    style: {
      fillRule: "nonzero"
    }
  }), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "pin-map"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRBill);
export default __webpack_public_path__ + "static/media/iconR-bill.c535a78bfd8fb7abd892660fae996d6b.svg";
export { ForwardRef as ReactComponent };